import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);
const store= new Vuex.Store({
    state:{
      nav:'/',
      username:''
    },
    mutations:{
      set_nav(state, nav) {
        state.nav = nav;
      },
      set_userId(state, userId) {
        state.userId = userId;
        sessionStorage.userId = userId
      },
      del_token(state) {
        state.token = '';
        sessionStorage.removeItem('token')
      },
    }
  })
;

export default  store



// WEBPACK FOOTER //
// ./src/store/store.js